import { render, staticRenderFns } from "./ActionMissingInfoPortingData.vue?vue&type=template&id=2645746c&scoped=true&"
import script from "./ActionMissingInfoPortingData.vue?vue&type=script&lang=js&"
export * from "./ActionMissingInfoPortingData.vue?vue&type=script&lang=js&"
import style0 from "./ActionMissingInfoPortingData.vue?vue&type=style&index=0&id=2645746c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645746c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
